import { ACCESS_TOKEN_KEY, cookieOptions } from '@/shared/constants'
import { setCookie } from 'nookies'

export const isDevelopment =
  process.env.NEXT_PUBLIC_ENVIROMENT === 'development'

export function setTokenOnCookies(token: string) {
  // Se for desenvolvimento, criar outro cookie com o domínio localhost
  if (isDevelopment) {
    setCookie(null, ACCESS_TOKEN_KEY, token, {
      ...cookieOptions,
      domain: 'localhost',
    })
  }

  setCookie(null, ACCESS_TOKEN_KEY, token, cookieOptions)
}
